<modal-panel title="App Insight Queries" data-testid="insight-queries-modal-panel" (close)="close()">
  <ng-container data-testid="insight-queries-modal-content">
    <app-insight-queries [showMoreBtn]="false"
                         [isModalView]="true"
                         [data]="data()"
                         [labels]="data().labels"
                         [presentationType]="presentationType()"/>
  </ng-container>

  <ng-container data-testid="insight-queries-modal-footer" modalPanelFooter>
    <button data-testid="insight-queries-modal-close-button" mat-raised-button color="primary" (click)="close()">Close</button>
  </ng-container>
</modal-panel>
